<template lang="html">
	<div :class="sendFormTime ? 'form-submit load' : 'form-submit'">
		<button @click='click' >
			<slot>Button name</slot>
		</button>
	</div>
</template>

<script>
module.exports = {
	name: 'submit',



	data() {
		return {
			validFlagsArray: [],
			validFlags: [],
			complete: true,
			identic: true,
			sendFormTime: false
		}
	},

	methods: {
		click(e) {
			this.validFlagsArray = [];
			this.complete = true;

			let payload = {};
			// this.$parent.$refs - це всі інпути, які внесені в refs батьківського компонента (форми)
			// console.log(this.validFlagsArray)
			// console.log(this.$parent.$refs)

			for (var component in this.$parent.$refs) {
				if (this.$parent.$refs.hasOwnProperty(component) && this.$parent.$refs[component].length) {
					try {
						this.$parent.$refs[component][0].validate();
						this.validFlags[component] = this.$parent.$refs[component][0].valid;
					}
					catch (err){
						console.log(err);
					}
					this.validFlagsArray.push([
						this.$parent.$refs[component][0].valid,
						this.$parent.$refs[component][0].$el.querySelector('input')
					]);
					// console.log(this.$parent.$refs[component][0].name);
					if(this.$parent.$refs[component][0].name){
						payload[this.$parent.$refs[component][0].name] = this.$parent.$refs[component][0].inputValue;
					}
				}
			}

			console.log(this.validFlagsArray);

			for(var i = 0; i < this.validFlagsArray.length; i++) {
				if(!this.validFlagsArray[i][0]) {
					this.complete = false;
					break;
				}
			}

			let t = setTimeout(() => {
				for (var component in this.$parent.$refs) {
					let str = this.$parent.$refs[component][0].$el.attributes.class.value;
					if(str.indexOf('incomplete')){
						console.log(this.$parent.$refs[component][0].$el.attributes.class.value);
						// this.complete = false;
					}
				}
			}, 300);

			// let el = document.querySelectorAll('.incomplete');
			console.log(e);
			var k = e.target.closest('.VueForm').classList[1];
			var el = document.querySelectorAll('.'+ k + ' .incomplete');


			if(this.complete) {
				// console.log(el.length);
				if(el.length == 0){
					this.$emit('COMPLETE', payload);
					this.sendFormTime = true
				}else {
					this.$emit('INCOMPLETE', this.validFlagsArray[i][1]);
				}
			}
			else {
				// alert('INCOMPLETE');
				this.$emit('INCOMPLETE', this.validFlagsArray[i][1]);
			}
		}
	}
}
</script>

<style lang="scss">
	.form-submit{
		position: relative;
		&.load{
			&:before{
				position: absolute;
				left: 10px;
				// background-image: url('#{$imgPathSCSS}orbit.gif');
				background-image: url('../img/spinning-circles.svg');
				top: calc(50% - 10px);
				width: 20px;
				height: 20px;
				content: "";
				background-size: cover;
			}
		}
	}
	button{
		height: 55px;
		border-radius: 25px;
		background-color: #e6b012;
		color: #21293b;
		border: 1px solid #e6b012;
		box-shadow:	0px 10px 25px 5px rgba(black,0.2);
		transition: all .5s ease-out 0s;
		&:hover, &:active, &:focus, {
			background-color: lighten(#e6b012, 5%);
			border-color: lighten(#e6b012, 5%);
		}
	}
</style>



// WEBPACK FOOTER //
// submit.vue?05fee369